import { TableLazyLoadEvent } from 'primeng/table';
import { FilterMetadata } from 'primeng/api/filtermetadata';

export interface TableRequest {
    pageNumber: number;
    pageSize: number;
    sort: {
        [field: string]: 'ASC' | 'DESC';
    };
    filters: {
        global: string;
        fields: {
            [field: string]: string | string[];
        };
    };
}

function getValueOfFilterMetadata(filterMetadata: FilterMetadata | FilterMetadata[]): string | string[] | undefined {
    if (!filterMetadata) return;
    return Array.isArray(filterMetadata) ? filterMetadata.map((metadata) => metadata.value) : filterMetadata.value;
}

export function mapLazyLoadEvent(lazyLoadEvent: TableLazyLoadEvent): TableRequest {
    const filters: { [field: string]: string | string[] } = {};
    for (const filter in lazyLoadEvent.filters) {
        const filterMetadata = lazyLoadEvent.filters[filter];
        if (filterMetadata) {
            if (filter !== 'global') {
                const value = getValueOfFilterMetadata(filterMetadata);
                if (value) {
                    filters[filter] = value;
                }
            }
        }
    }

    const sort: { [field: string]: 'ASC' | 'DESC' } = {};
    if (lazyLoadEvent.multiSortMeta) {
        lazyLoadEvent.multiSortMeta.forEach((multiSort) => (sort[multiSort.field] = multiSort.order === 1 ? 'ASC' : 'DESC'));
    } else if (lazyLoadEvent.sortField) {
        if (Array.isArray(lazyLoadEvent.sortField)) {
            lazyLoadEvent.sortField.forEach((sortField) => (sort[sortField] = lazyLoadEvent.sortOrder === 1 ? 'ASC' : 'DESC'));
        } else {
            sort[lazyLoadEvent.sortField] = lazyLoadEvent.sortOrder === 1 ? 'ASC' : 'DESC';
        }
    }

    const rows = lazyLoadEvent.rows ?? 15;

    return {
        pageNumber: (lazyLoadEvent.first ?? 0) / rows + 1,
        pageSize: lazyLoadEvent.rows ?? 15,
        filters: {
            global: Array.isArray(lazyLoadEvent.globalFilter) ? lazyLoadEvent.globalFilter[0] : lazyLoadEvent.globalFilter ?? '',
            fields: filters
        },
        sort
    };
}
